import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Solutiontruth() {
  return (
    <section className="challenge_par client_truth p-100 text_second_text">
      <Container>
        <Row>
          <Col xs={12} md={5} lg={5} xl={5} xxl={5} className="my-auto">
            <h2>
              The <span>Solution</span>
            </h2>
            <p>
              TekRevol addressed the client's concerns by developing TruthGPT,
              an AI-powered mobile app designed to be the antidote to
              misinformation.
            </p>
            <p>
              The app empowers users by delivering accurate, unbiased
              information through an advanced chatbot interface.
            </p>
            <p>
              The incorporation of blockchain technology ensures transparency
              and security, while the 3D character, Truthie, adds an engaging
              and visually appealing element to the user experience.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto offset-xl-2 offset-lg-2 offset-md-1"
          >
            <div className="challenge_img text-center">
              <StaticImage
                src="../../../images/case-studies/truth-gpt/The_Solution.webp"
                alt="TekRevol"
                className=""
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={733}
                height={693}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Solutiontruth;
